import { createAction } from 'redux-actions';
import * as actionTypes from './constants';

export const fetchCustomerCenterConfiguration =
  createAction(actionTypes.FETCH_CUSTOMER_CENTER_CONFIGURATION_REQUEST);
export const fetchCustomerCenterConfigurationSuccess =
  createAction(actionTypes.FETCH_CUSTOMER_CENTER_CONFIGURATION_SUCCESS);
export const fetchCustomerCenterConfigurationFailure =
  createAction(actionTypes.FETCH_CUSTOMER_CENTER_CONFIGURATION_FAILURE);

export const updateCustomerCenterConfiguration =
  createAction(actionTypes.UPDATE_CUSTOMER_CENTER_CONFIGURATION_REQUEST);
export const updateCustomerCenterConfigurationSuccess =
  createAction(actionTypes.UPDATE_CUSTOMER_CENTER_CONFIGURATION_SUCCESS);
export const updateCustomerCenterConfigurationFailure =
  createAction(actionTypes.UPDATE_CUSTOMER_CENTER_CONFIGURATION_FAILURE);

export const resetConfigurationSuccess =
  createAction(actionTypes.RESET_CONFIGURATION_SUCCESS);
